import React from 'react';
import PropTypes from 'prop-types';

const Contributions = (props) => {
	var contribs = props.contributions.map((c, i) =>
		<li key={i} className="comp__project-list__item">
			<h6>{c.title}</h6>
			<p>{c.description}</p>
		</li>
	);

	return (
		<ul className="small-block-grid-1 medium-block-grid-2 large-block-grid-3">
			{contribs}
		</ul>
	);
};

Contributions.propTypes = {
	contributions: PropTypes.array.isRequired
};

Contributions.defaultProps = {
	contributions: []
};

export default Contributions;


// WEBPACK FOOTER //
// ./app/js/module/contributions.jsx